const Icon = ({
  width = 57,
  height = 57,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <rect width={width} height={height} rx={12} fill="#C8FFC7" />
      <path
        d="M38.5113 19.4632H33.1244V17.0681C33.1244 15.9277 32.2835 15 31.2499 15H25.75C24.7165 15 23.8756 15.9277 23.8756 17.0681V19.4632H18.4887C17.1164 19.4632 16 20.695 16 22.2092V36.2541C16 37.7682 17.1164 39 18.4887 39H38.5113C39.8835 39 41 37.7682 41 36.2541V22.2092C41 20.695 39.8835 19.4632 38.5113 19.4632ZM25.4632 17.0681C25.4632 16.8937 25.5919 16.7518 25.75 16.7518H31.2499C31.4081 16.7518 31.5367 16.8937 31.5367 17.0681V19.4632H25.4632V17.0681ZM17.5877 22.2092C17.5877 21.6609 17.9919 21.2149 18.4887 21.2149H38.5113C39.0081 21.2149 39.4123 21.6609 39.4123 22.2092V23.5055C39.4123 24.7215 38.6734 25.808 37.6153 26.1479L29.3127 28.8152C28.781 28.986 28.219 28.986 27.6873 28.8152L19.3847 26.1479C18.3266 25.808 17.5877 24.7215 17.5877 23.5055V22.2092ZM38.5113 37.2483H18.4887C17.9919 37.2483 17.5877 36.8023 17.5877 36.2541V27.0719C17.9877 27.4131 18.4437 27.6701 18.9408 27.8298C28.1124 30.7762 27.6411 30.6951 28.5 30.6951C29.3703 30.6951 28.8768 30.7796 38.0591 27.8298C38.5563 27.6701 39.0123 27.4131 39.4123 27.0719V36.2541C39.4123 36.8023 39.0081 37.2483 38.5113 37.2483Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default Icon;
